export default __webpack_public_path__ + "884355f63f9881d844f92d13334ffcd0.png";